import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import BackButton from './BackButton';
import ForwardButton from './ForwardButton';
import { routes } from './nav/Nav';
import NavLine from './nav/NavLine';

export class PageContainer extends React.Component {
  render() {
    let currentRoute = routes.find(routeItem => routeItem.path === this.props.location.pathname)?.label || 'Skin Remembers';
    return (
      <div className={"page-container " + this.props.className} style={this.props.style}>
        <Helmet>
          <title>{currentRoute}</title>
        </Helmet>

        {this.props.children}
        {
          routes.some(routeItem => routeItem.path === this.props.location.pathname) &&
          [<NavLine key="nav-line" />,
          <BackButton key="back-button" {...this.props} />,
          <ForwardButton key="forward-button" {...this.props} />]
        }
      </div>

    );
  }
}

export default withRouter(PageContainer);
